/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {FCVirtualScrollerDefaultOptions} from './model/fc-virtual-scroller-default-options.model';


/**
 * Initialize FCVirtualScrollerDefaultOptions.
 *
 * @returns FCVirtualScrollerDefaultOptions.
 */
export function FC_VIRTUAL_SCROLLER_DEFAULT_OPTIONS_FACTORY(): FCVirtualScrollerDefaultOptions {
    return {
        checkResizeInterval: 1000,
        modifyOverflowStyleOfParentScroll: true,
        resizeBypassRefreshThreshold: 5,
        scrollAnimationTime: 750,
        scrollDebounceTime: 0,
        scrollThrottlingTime: 0,
        stripedTable: false
    } as FCVirtualScrollerDefaultOptions;
}